export default  [
    {
        title: '摩拜单车',
        link: 'http://m.sohu.com/feed'
    },
    {
        title: '蔚来单车',
        link: 'http://m.sohu.com/feed'
    },
    {
        title: '共享经济',
        link: 'http://m.sohu.com/feed'
    },
    {
        title: '共享汽车',
        link: 'http://m.sohu.com/feed'
    },
    {
        title: '摩拜数据',
        link: 'http://m.sohu.com/feed'
    },
    {
        title: '摩拜单车',
        link: 'http://m.sohu.com/feed'
    },
    {
        title: '蔚来单车',
        link: 'http://m.sohu.com/feed'
    },
    {
        title: '共享经济',
        link: 'http://m.sohu.com/feed'
    }
]


// WEBPACK FOOTER //
// ./src/_store/nav_list_dic.js